import React from "react";
import PropTypes from "prop-types";

import { useStaticQuery, graphql } from "gatsby";

export const Seo = ({
  title,
  description,
  image,
  lang,
  pathname,
  children,
}) => {
  const { site } = useStaticQuery(query);
  const { defaultTitle, siteUrl } = site.siteMetadata;
  const seo = {
    title: title ? `${defaultTitle} | ${title}` : defaultTitle,
    description: description || "",
    image: image || "",
    url: pathname ? `${siteUrl}${pathname}` : siteUrl,
  };
  return (
    <>
      <html lang={lang} />

      <title>{seo.title}</title>

      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1"
      />
      <meta name="robots" content="noindex, nofollow" />
      <meta name="googlebot" content="noindex, nofollow" />

      {seo.url && <meta property="og:url" content={seo.url} />}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.description && (
        <meta property="og:description" content={seo.description} />
      )}
      {seo.image && <meta property="og:image:secure_url" content={seo.image} />}
      {seo.image && <meta property="og:image" content={seo.image} />}

      {seo.title && <meta name="twitter:title" content={seo.title} />}
      {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )}
      {seo.image && <meta name="twitter:image" content={seo.image} />}

      {children}
    </>
  );
};

Seo.propTypes = {
  title: PropTypes.string,
};
Seo.defaultProps = {
  title: null,
};

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        defaultTitle: title
        siteUrl
      }
    }
  }
`;
